import { create } from "zustand";

import {
  ProviderSdkBundleResponse,
  ProviderSdkConfigResponse,
} from "src/clients/sdk";

export type SdkModal =
  | { kind: "none" }
  | { kind: "editBundle"; bundle: ProviderSdkBundleResponse }
  | { kind: "deleteBundle"; bundle: ProviderSdkBundleResponse }
  | { kind: "addScriptToBundle"; script: ProviderSdkConfigResponse }
  | { kind: "editScript"; script: ProviderSdkConfigResponse }
  | { kind: "deleteScript"; script: ProviderSdkConfigResponse };

type SdkManagementState = {
  modal: SdkModal;
};

type SdkManagementActions = {
  openEditBundle: (bundle: ProviderSdkBundleResponse) => void;
  openDeleteBundle: (bundle: ProviderSdkBundleResponse) => void;
  openAddScriptToBundle: (script: ProviderSdkConfigResponse) => void;
  openEditScript: (script: ProviderSdkConfigResponse) => void;
  openDeleteScript: (script: ProviderSdkConfigResponse) => void;
  closeModal: () => void;
};

type SdkManagementStore = ZustandStore<
  SdkManagementState,
  SdkManagementActions
>;

const useSdkManagementStore = create<SdkManagementStore>((set) => ({
  modal: { kind: "none" },
  actions: {
    openEditBundle: (bundle) => set({ modal: { kind: "editBundle", bundle } }),
    openDeleteBundle: (bundle) =>
      set({ modal: { kind: "deleteBundle", bundle } }),
    openAddScriptToBundle: (script) =>
      set({ modal: { kind: "addScriptToBundle", script } }),
    openEditScript: (script) => set({ modal: { kind: "editScript", script } }),
    openDeleteScript: (script) =>
      set({ modal: { kind: "deleteScript", script } }),
    closeModal: () => set({ modal: { kind: "none" } }),
  },
}));

export const useSdkManagementActions = () =>
  useSdkManagementStore((state) => state.actions);

export const useSdkModal = () => useSdkManagementStore((state) => state.modal);
